/**
 * Modern units like dvh (dynamic viewport height) are not supported on old mobile devices.
 * To propose a fallback version of the full viewport height,
 * we can remove some pixels (mobile toolbar height).
 * Found here: https://forums.developer.apple.com/forums/thread/662466
 */
export const mobileToolbarHeight = 50;
